import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchTrippers = createAsyncThunk(
  "tripper/fetchTrippers",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/shopper/tips", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const tripperSlice = createSlice({
  name: "tripper",
  initialState: {
    trippers: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTrippers.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchTrippers.fulfilled, (state, action) => {
        state.status = "success";
        state.trippers = action.payload.data;
      })
      .addCase(fetchTrippers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default tripperSlice.reducer;
